import { get } from "react-hook-form";
import api from "."


export default {
    saveSmiTest: (results) => {
        const res = api.post(`/api/test/save`, { type: 'SMI', results });
        return res;
    },
    saveYoungTest: (results) => {
        const res = api.post(`/api/test/save`, { type: 'Young', results });
        return res;
    },
    saveBeckTest: (results) => {
        const res = api.post(`/api/test/save`, { type: 'Beck', results });
        return res;
    },
    getResults: (id) => {
        const res = api.get(`/api/test/${id}`);
        return res;
    },
    getResultsByUser: (page, limit) => {
        const res = api.get(`/api/test`, { params: { page, limit } });
        return res;
    },
    getTestResultsByUserAsAdmin: (id, page, limit) => {
        const res = api.get(`/api/test/byUser/${id}`, { params: { page, limit } });
        return res;
    },
    getTestStatus: (type) => {
        const res = api.get(`/api/test/status/${type}`);
        return res;
    },
    getTestStatusByUser: (id, type) => {
        const res = api.get(`/api/test/status/${id}/${type}`);
        return res;
    },
    getTestResultsByType: (type) => {
        const res = api.get(`/api/test/${type}/results`);
        return res;
    },
    getTestResultsByUser: (id, type) => {
        const res = api.get(`/api/test/${type}/${id}/results`);
        return res;
    },
    saveAnonResults: (results, token) => {
        const res = api.post(`/api/test/anon/save`, { results, Headers: { Authorization: `Bearer ${token}` } });
        return res;
    },
}